module.exports = __webpack_public_path__ + "img/carousel-inline.6a37dcc4.png";